<template>
  <!-- 路由跳转 -->

  <div class="navLink flex-between-wrap">
    <div v-for="(item,index) in navLinkList" :key="index" class="linkItem" @click="linkToPage($event,index)">
		<!-- 首页，需要空一个位置 -->
		<div v-if="index==0" style="letter-spacing: 1em;"> {{$t('navLink')[index].name}}</div>
      {{$t('navLink')[index].name}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navLink',
    data() {
      return {
        navLinkList: [{
            id: 1,
            name: '首頁',
            link: '/'
          },
          {
            id: 2,
            name: '耕雲導師',
            link: '/plowCloudMentor'
          },
          {
            id: 3,
            name: '安祥禪法寶',
            link: '/magicWeapon'
          },
          {
            id: 4,
            name: '禪友文訊',
            link: '/friendWen'
          },
          {
            id: 5,
            name: '結缘品及下載',
            link: '/greenAndDownload'
          },
          {
            id: 6,
            name: '活動訊息',
            link: '/information'
          }
        ]
      }
    },
    methods: {
      linkToPage(e, index) {
        this.$router.push({
          path: this.navLinkList[index].link
        })
          localStorage.setItem("nowNav_type",1);
        // window.
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navLink {
    /* display: grid;
    grid-template-columns: repeat(3, 33.3%);
    grid-row-gap: 0.1rem;
    grid-column-gap: 0.1rem; */

    margin-top: 0.53rem;
    margin-bottom: 0.53rem;
  }

  .linkItem {
    background-color: #047BCD;
    width: 6.61rem;
    height: 1.92rem;
    line-height: 1.92rem;
    color: #fff;
    font-weight: 600;
    font-size: 0.85rem;
    box-sizing: border-box;
    margin-bottom:0.1rem;
	text-align: left;
	padding-left: 0.8rem;
	box-sizing: border-box;

  }

  .linkItem a {
    color: #fff;
    text-decoration: none;
  }
</style>
